import { useMemo } from 'react';
import type { EditableTableProps } from '@timeedit/ui-components';
import { Flex } from '@timeedit/ui-components/antd';

export const useFooter = (footerContent?: React.ReactNode[]) =>
  useMemo(
    (): EditableTableProps['footer'] => () => {
      if (!footerContent || footerContent.length === 0) {
        return null;
      }

      return (
        <Flex className="te-gap-2">
          {footerContent.map((action, index) => (
            <Flex key={index}>{action}</Flex>
          ))}
        </Flex>
      );
    },
    [footerContent]
  );
